import type { Moment } from '@this/src/lib/moment';
import moment from '@this/src/lib/moment';
import { observable } from 'mobx';

export interface HotelOrderItemEanTotalArgs {
  reservation_date: string;
  hotel_element_total: number;
  hotel_element_price_total: number;
  order_item_original_price_total: number;
  order_item_original_price_price_total: number;
  order_item_price_details_price_total: number;
  ean_record_total: number;
  ean_record_price_total: number;
  exact_match: boolean;
}

export interface HotelOrderItemEanTotalProps {
  reservationDate: Moment;
  hotelElementTotal: number;
  hotelElementPriceTotal: number;
  orderItemOriginalPriceTotal: number;
  orderItemOriginalPricePriceTotal: number;
  orderItemPriceDetailsPriceTotal: number;
  eanRecordTotal: number;
  eanRecordPriceTotal: number;
  exactMatch: boolean;
}

export const convertHotelOrderItemEanTotal = (args: HotelOrderItemEanTotalArgs): HotelOrderItemEanTotalProps => ({
  reservationDate: moment(args.reservation_date),
  hotelElementTotal: args.hotel_element_total,
  hotelElementPriceTotal: args.hotel_element_price_total,
  orderItemOriginalPriceTotal: args.order_item_original_price_total,
  orderItemOriginalPricePriceTotal: args.order_item_original_price_price_total,
  orderItemPriceDetailsPriceTotal: args.order_item_price_details_price_total,
  eanRecordTotal: args.ean_record_total,
  eanRecordPriceTotal: args.ean_record_price_total,
  exactMatch: args.exact_match
});

export default class HotelOrderItemEanTotal {
  @observable readonly reservationDate: Moment;

  @observable readonly hotelElementTotal: number;

  @observable readonly hotelElementPriceTotal: number;

  @observable readonly orderItemOriginalPriceTotal: number;

  @observable readonly orderItemOriginalPricePriceTotal: number;

  @observable readonly orderItemPriceDetailsPriceTotal: number;

  @observable readonly eanRecordTotal: number;

  @observable readonly eanRecordPriceTotal: number;

  @observable readonly exactMatch: boolean;

  constructor(args: HotelOrderItemEanTotalProps) {
    this.reservationDate = args.reservationDate;
    this.hotelElementTotal = args.hotelElementTotal;
    this.hotelElementPriceTotal = args.hotelElementPriceTotal;
    this.orderItemOriginalPriceTotal = args.orderItemOriginalPriceTotal;
    this.orderItemOriginalPricePriceTotal = args.orderItemOriginalPricePriceTotal;
    this.orderItemPriceDetailsPriceTotal = args.orderItemPriceDetailsPriceTotal;
    this.eanRecordTotal = args.eanRecordTotal;
    this.eanRecordPriceTotal = args.eanRecordPriceTotal;
    this.exactMatch = args.exactMatch;
  }
}
